import { Download } from "hec/assets/icons";
import { BodyCopy } from "hec/components/ui/body-copy";
import { LinkRender } from "hec/components/ui/link-render";
import type React from "react";
import { useState } from "react";

import { cn } from "~/lib/utils";

export interface DownloadAssetButtonProps {
  asset: string;
  fileName: string;
  ctaText: string;
  className?: string;
  [key: string]: any; // For ...props
}

export const DownloadAssetButton = ({
  asset,
  fileName,
  ctaText,
  className,
  "data-testid": dataTestId,
  ...props
}: DownloadAssetButtonProps) => {
  const [error, setError] = useState<string | null>(null);

  const handleDownload = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    try {
      const response = await fetch(asset);
      if (!response.ok) {
        setError("Download failed.");
        return;
      }

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName || "download";
      document.body.appendChild(link);
      link.click();

      URL.revokeObjectURL(blobUrl);
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download failed:", error);
      setError("Download failed.");
    }
  };

  return (
    <div className={cn("flex items-center", className)} {...props}>
      <button
        onClick={handleDownload}
        className="flex items-center"
        data-testid={dataTestId}
      >
        <Download className="mr-1 h-5 w-5 text-blue-04" />
        <LinkRender
          ctaType="link"
          variant="normal"
          asChild
          className="mt-1 underline"
          data-testid="downloadAssetButton"
        >
          {ctaText}
        </LinkRender>
      </button>
      {error && (
        <BodyCopy
          className="ml-3 mt-1 text-error"
          size="small"
          data-testid="downloadAssetButton-BodyCopy"
        >
          {error}
        </BodyCopy>
      )}
    </div>
  );
};
